import React, { FC, memo, useMemo } from 'react';
import { gray } from '../../../../../components/Color';
import { FlexGrid } from '../../../../../components/FlexGrid';
import { ModFlexwijerNews } from '../../../../../components/Icons/ModFlexwijerNews';
import { ModGossip } from '../../../../../components/Icons/ModGossip';
import { Paperclip } from '../../../../../components/Icons/Paperclip';
import { User } from '../../../../../components/Icons/User';
import { PaddingBox } from '../../../../../components/PaddingBox';
import { CommunitiesListItem } from '../../types';

type CommunitiesListItemCountersProps = Partial<
	Pick<CommunitiesListItem, 'commentsCount' | 'membersCount' | 'attachmentsCount' | 'newsCount'>
>;

export const CommunitiesListItemCounters: FC<React.PropsWithChildren<CommunitiesListItemCountersProps>> = memo(
	({ newsCount, membersCount, commentsCount, attachmentsCount }) => {
		const countersModel = useMemo(() => {
			return [
				{
					count: membersCount,
					icon: <User fill={gray[5]} />,
				},
				{
					count: newsCount,
					icon: <ModFlexwijerNews fill={gray[5]} />,
				},
				{
					count: attachmentsCount,
					icon: <Paperclip fill={gray[5]} />,
				},
				{
					count: commentsCount,
					icon: <ModGossip fill={gray[5]} />,
				},
			].filter((i) => typeof i.count === 'number');
		}, [attachmentsCount, commentsCount, membersCount, newsCount]);

		return (
			<FlexGrid
				center
				wrap
			>
				{countersModel.map((counter, index) => (
					<PaddingBox
						rightSmall
						key={index}
					>
						<FlexGrid>
							{counter.icon}
							<PaddingBox leftScanty>{counter.count}</PaddingBox>
						</FlexGrid>
					</PaddingBox>
				))}
			</FlexGrid>
		);
	},
);
